import { selectCurrentEntitiesDenormalizedByType } from 'ducks/entities/selectors'
import { createBasicSelector } from 'util/redux'

export const selectSetupIntents = createBasicSelector(state =>
  selectCurrentEntitiesDenormalizedByType(state, 'setupIntent')
)
